import { IonAlert, IonContent, IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/react'
import { createOutline, trashOutline } from 'ionicons/icons'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, setModeloEditHide, setModeloEditShow } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

export const ModeloItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { modelo = "" } } = useSelector((state: RootState) => state.equipo);
  const { editModelo } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {}
  const handleUpdate = () => {
    dispatch(setModeloEditShow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Modelo
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{modelo}</IonLabel>
          {editModelo && <ModeloModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const ModeloModal: FC = () => {
  const dispatch = useDispatch();
  const { editModelo } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const equipo = {
    tag: activeEquipo.tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type,
    modelo: activeEquipo.modelo,
  }
  const { modelo = '' } = activeEquipo;

  const handleUpdate = ({ name }) => {
    dispatch(setActiveLoading());
    equipo.modelo = name
    dispatch(startEquipoUpdated(equipo));
    dispatch(setModeloEditHide())
  };

  const handleClose = () => {
    dispatch(setModeloEditHide());
  };
  return (
    <IonContent>
      <IonAlert
        isOpen={editModelo}
        onDidDismiss={handleClose}
        header={'Modelo'}
        inputs={[
          {
            name: 'name',
            type: 'text',
            placeholder: 'Modelo',
            value: modelo
          },
        ]}
        buttons={[
          {
            text: 'Guardar',
            handler: (e) => {
              handleUpdate(e);
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {}
          }          
        ]}
      />
    </IonContent>
  );
}
